<template>
  <div class="zhihuwenda-mian">
    <div class="pic" :style="{backgroundImage: 'url('+icon_down3+')'}"></div>
    <p class="txt0"> 日历当前软件版本较低 </p>
    <p class="txt1"> 请按下述步骤升级日历然后再配置Wi-Fi </p>
    <div class="two">
    <p class="div_title">第一步 设置手机热点  </p>
    <p>1.手机热点名称设置为MmcFacBj；</p>
    <p>2.手机热点密码设置为12345678；。</p>
    <p class="zhu">注：iOS用户需要在手机设置->通用->关于本机中把手机名称更改为MmcFacBj，然后再设置手机热点。</p>
    </div>
    <div class="three">
    <p class="div_title">第二步 升级日历版本  </p>
    <p>长按日历右键联网，日历会自动拉取最新的软件版本，整个升级过程需要联网2~3次。</p>
     <p>如多次尝试联网日历依然显示“联网失败”，请检查以下几点：</p>
    <p>1.手机热点没有限制设备连接数；</p>
    <p>2.热点能正常工作（检查方式：其它手机可以通过热点上网）。</p>
    <p>3.手机热点如果设置频段需设置为2.4G频段。</p>
    </div>
    <div class="four">
    <p class="div_title">第三步 检查升级结果 </p>
    <p>1.点这里检查是否完成版本升级。</p>
      <button class="titBtn"  @click="getversion" >
        点击检测
      </button>
    <Upgrade-Tips v-show="UpgradeTips" @cancel="cancel" @sure="sure" :text2="txt2" :text="text" :qx="qxtxt"></Upgrade-Tips>
    <p>2.如多次尝试依然不成功，请通过微信公众号联系客服。</p>
    </div>
  </div>
</template>
<script>

import Common from '../../assets/js/common'
// eslint-disable-next-line no-unused-vars
import UpgradeTips from '../../components/UpgradeTips/UpgradeTips'
import axios from 'axios'
var isLocal = Common.getEvn()
var api = process.env.BASE_URL
export default {
  name: 'UpgradeVersionInstructions',
  components: {
    UpgradeTips
  },
  data () {
    return {
      date: '',
      show: false,
      btnMode: 1,
      UpgradeTips: false,
      userId: localStorage.getItem('max_userId'),
      deviceId: localStorage.getItem('max_device_id'),
      imgSrc2: Common.staticHref() + 'img/bg@2x.png',
      imgSrc3: Common.staticHref() + 'img/bg3x.png',
      icon_down2: Common.staticHref() + 'img/icon_down@2x.png',
      icon_down3: Common.staticHref() + 'img/icon_down@3x.png',
      txt2: '',
      text: '',
      qxtxt: '1'
    }
  },
  methods: {
    getversion (e) {
      if (isLocal === 'local') {
        axios.post('/Calendar/api/version/get/device/version/', {
          'device_id': 232,
          'user_id': this.userId
        })
        .then(res => {
          // eslint-disable-next-line no-unused-vars
          var _res = res.data
          if (_res.result === 0) {
            this.text = '升级成功'
            this.txt2 = '当前设备版本为' + _res.data.sw
            this.cancelHandle()
          } else if (_res.result === 3) {
            alert('升级失败  当前设备版本为：' + _res.data.sw)
          } else {
            alert('升级失败  当前设备版本为：' + _res.data.sw)
          }
        })
        .catch(this.getChannelsErr())
      } else {
        axios.post(api + '/Calendar/api/version/get/device/version/', {
          'device_id': this.deviceId,
          'user_id': this.userId
        })
        .then(res => {
          // eslint-disable-next-line no-unused-vars
          var _res = res.data
          if (_res.result === 0) {
            this.text = '升级成功'
            this.txt2 = '当前设备版本为' + _res.data.sw
            this.cancelHandle()
          } else if (_res.result === 3) {
            alert('升级失败  当前设备版本为：' + _res.data.sw)
          } else {
            alert('升级失败  当前设备版本为：' + _res.data.sw)
          }
        })
        .catch(this.getChannelsErr)
      }
    },
    getChannelsErr () {
      alert('检测失败')
    },
    // 1
    settingWaterSucc (res) {
      this.toast.hide()
      var _res = res.data
      if (_res.result !== 0) {
        console.log(_res.result)
      } else {
        this.showTip = true
        this.PillsWarnInfo(_res.reminder_info[1][2])
        this.init()
      }
    },
    cancelHandle () {
      this.UpgradeTips = true
    },
    sureHandle () {
      this.UpgradeTips = true
    },
    cancel () {
      this.UpgradeTips = false
    },
    sure () {
      this.loadSurvey = false
      this.$nextTick(() => {
        this.loadSurvey = true
        this.getChannels()
      })
      this.UpgradeTips = false
      this.btnMode = 1
      this.$router.back()
    }
  }
}
</script>

<style  lang="stylus" scoped>
.zhihuwenda-mian
  position absolute
  background-color: #F1F0F7
.pic
  height 95px
  width 95px
  margin-left 140px
  margin-right 10px
  margin-top 46px
  background-position center center
  background-repeat no-repeat
  background-size contain
.txt0
  font-family: PingFangSC-Semibold;
  font-size: 20px;
  color: #333333;
  letter-spacing: 0;
  text-align: center;
.txt1
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #333333;
  letter-spacing: 0;
  text-align: center;
.one
  background: #FFFFFF;
  border: 1px solid #4D4390;
  border-radius: 10px;
  margin 10px;
  height 288px;
  width 345px;
  /*border-radius: 10px;*/
.two
  background: #FFFFFF;
  border: 1px solid #4D4390;
  border-radius: 10px;
  margin 10px;
  height 168px;
  width 345px;
.three
  background: #FFFFFF;
  border: 1px solid #4D4390;
  border-radius: 10px;
  margin 10px;
  height 264px;
  width 345px;
.four
  background: #FFFFFF;
  border: 1px solid #4D4390;
  border-radius: 10px;
  margin 10px;
  height 224px;
  width 345px;
.four .button
    background: #4D4390;
    border: 1px solid #4E4390;
    border-radius: 20px;
    margin auto;
.dianjitext
  font-size: 14px;
  color: #FFFFFF;
  margin-left: 5px;
.titBtn {
  font-size: 14px;
  color: #FFFFFF;
  margin-top: 20px;
  margin-left: 3.5vw;
  /* border-width: 0; */
  background-color: #4E4390;
  height: 40px;
  width: 315px;
  border-radius: 22px;
  flex-direction: row;
  text-align: left;
  margin-bottom: 5px;
  align-items: center;
  justify-content: center;
  display: flex;
  /* flex-flow: column; */
  /* padding-bottom: 17px; */
}

.div_title
  font-family: PingFangSC-Semibold;
  font-size: 16px;
  color: #4D4390;
  letter-spacing: 0;
  margin-top 20px;
  text-align: center;
.div_pi
  height 69px
  width 262px
  margin-left 44px
  margin-right 10px
  margin-top 27px;
  // margin-top 15px
  background-position center center
  background-repeat no-repeat
  background-size contain
p
  margin-top 12px;
  font-size: 14px;
  margin-left 15px;
  margin-right 15px;
.zhu
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #666666;
  letter-spacing: 0;
  text-align: justify;
.btn-box
  .btn
    width 50%
    height 57px
    color #333333
    background #ffffff
    font-size 16px
    box-sizing border-box
  .cancel
    border-bottom-left-radius 10px
    border-right 1px solid #ededed
  .sure
    border-bottom-right-radius 10px
    color #334f5f
</style>



// WEBPACK FOOTER //
// src/pages/UpgradeVersionInstructions2/UpgradeVersionInstructions2.vue